module.exports = __webpack_public_path__ + "img/liangguangmochoubiandaiWu.min.cf618345.png";